import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircleDash = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.55181 2.51436C9.50832 2.3279 10.4918 2.3279 11.4483 2.51436M14.2686 3.68059C15.0783 4.22807 15.7746 4.92691 16.3191 5.73865M17.4853 8.55132C17.6718 9.50783 17.6718 10.4913 17.4853 11.4478M16.3191 14.2681C15.7716 15.0779 15.0727 15.7741 14.261 16.3186M11.4483 17.4848C10.4918 17.6711 9.50833 17.6711 8.55181 17.4848M5.73151 16.3186C4.9218 15.7711 4.22555 15.0723 3.68108 14.2605M2.51485 11.4478C2.32838 10.4913 2.32838 9.50783 2.51485 8.55132M3.68108 5.73102C4.22856 4.92131 4.9274 4.22507 5.73913 3.68059",
		stroke: "#71717A",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgCircleDash);
export default ForwardRef;
